import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to conditionally load and style the Swifty Chat widget
 * Excludes the widget from public showroom pages
 */
const useSwiftyChat = () => {
	const location = useLocation();

	useEffect(() => {
		const isPublicShowroom = location.pathname.match(/^\/p\/[^/]+\/showrooms\/[^/]+/);

		if (isPublicShowroom) {
			return;
		}

		if (document.getElementById('swifty-chat-script')) {
			return;
		}

		(window as any).helpjuice_account_url = 'https://help.launchmetrics.com';
		(window as any).helpjuice_contact_us_url = 'https://help.launchmetrics.com/contact-us';
		(window as any).helpjuiceSwiftyConfig = {
			subdomain: 'launchmetrics',
			widgetPosition: 'bottomRight',
			themeColor: '#4DF7B9',
			linksColor: '#1D4C56',
			chatHeader: 'Launchmetrics Support Chatbot - Beta',
			chatWelcomeHeader: 'Launchmetrics Automated Chat - Beta',
			chatWelcomeMessage: 'Ask me anything - Kindly ensure to mention the specific product in question for more precise outcomes.',
			chatInputPlaceholder: 'How can we help? ',
			chatIconUrl: 'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/8539/direct/1749727554591/newlogoblack.png',
			chatNoResultsMessage: "Sorry, we couldn't find any results. Please contact support@launchmetrics.com for assistance "
		};

		const script = document.createElement('script');
		script.id = 'swifty-chat-script';
		script.src = 'https://help.launchmetrics.com/swifty_chat.js';
		script.async = true;

		const injectStyles = (retries: number = 0) => {
			const maxRetries = 1;
			const container = document.getElementById('swifty-chatbot-container');

			if (container && (container as any).shadowRoot) {
				const style = document.createElement('style');
				style.textContent = `
                    #ai-assistant {
                        z-index: 4 !important;
                    }
					button {
						margin-right: 5px !important;
					}
				`;
				(container as any).shadowRoot.appendChild(style);
			} else if (retries < maxRetries) {
				setTimeout(() => injectStyles(retries + 1), 100);
			} else {
				console.warn('Swifty Chat shadow root not found after maximum retries');
			}
		};

		script.onload = () => {
			setTimeout(() => injectStyles(0), 100);
		};

		document.body.appendChild(script);

		return () => {
			const scriptElement = document.getElementById('swifty-chat-script');
			if (scriptElement) {
				scriptElement.remove();
			}
			const container = document.getElementById('swifty-chatbot-container');
			if (container) {
				container.remove();
			}
		};
	}, [location.pathname]);
};

export default useSwiftyChat;
